import Icon from "@ant-design/icons";
export const CustomIcon = ({ svg }) => (
  <Icon component={svg} style={{ fontSize: "21px" }} />
);
